export function formatTime(seconds: number, showSeconds: boolean = true) {
	if (Number.isNaN(seconds)) {
		seconds = 0;
	}

	const h = Math.floor(seconds / 3600);
	const m = Math.floor((seconds % 3600) / 60);
	const s = Math.floor(seconds % 60);

	let timeParts = [];

	timeParts.push(m);

	if (showSeconds) {
		timeParts.push(s);
	}

	if (h > 0) {
		timeParts.unshift(h);
	}
	timeParts = timeParts.map((t) => t.toString().padStart(2, '0'));

	return timeParts.join(':');
}
